import { memo } from "react";
import { Popup } from "react-leaflet";

const CustomPopup = ({ popUpDetails }) => {
  const { latLng, location } = popUpDetails || {};

  return latLng ? <Popup position={latLng}>{location}</Popup> : null;
};

export default memo(CustomPopup);
